import { useLocation } from 'react-router-dom';
import { SignUpForm } from '@/components/organisms/SignUpForm';
import { LoginPage } from '@/components/pages/LoginPage';
import { AuthTemplate } from '@/components/templates/AuthTemplate';
import { useAuthRedirect } from '@/hooks/useAuthRedirect';
import type { AuthProps } from '@/types/auth'; // Reusing AuthProps for setIsLoggedIn etc.

export const Home = ({ isLoggedIn, setIsLoggedIn, loading, setLoading }: AuthProps) => {
  const location = useLocation();

  // Redirect if already logged in
  useAuthRedirect(isLoggedIn);

  const isSignUp = location.pathname === '/signup';

  return (
    <AuthTemplate>
      {isSignUp ? (
        <SignUpForm />
      ) : (
        <LoginPage setIsLoggedIn={setIsLoggedIn} loading={loading} setLoading={setLoading} />
      )}
    </AuthTemplate>
  );
};

export default Home;
